const deepResearchFindings = ({ sellerProfileId = "", starters = [], contactId = "", phase = "", actions = {} } = {}) => {
  const out = [];
  if (!sellerProfileId) {
    out.push({ tone: "warn", key: "no_profile", label: "No seller profile", text: "Research without one is generic. Create yours once.", actions: actions.createProfile ? [{ label: "Create profile", run: actions.createProfile }] : [] });
  }
  if (phase === "complete" && (starters || []).length) {
    out.push({ tone: "hot", key: "build_sequence", label: "Turn this into a sequence", text: "I can draft a 3-step sequence from these starters.", actions: actions.buildSequence ? [{ label: "Draft it", run: actions.buildSequence }] : [] });
  }
  if (phase === "complete" && contactId) {
    out.push({ tone: "neutral", key: "add_to_sequence", label: "Add them to a sequence", text: "Research is done. Put them in motion.", actions: actions.addToSequence ? [{ label: "Add to sequence", run: actions.addToSequence }] : [] });
  }
  if (phase === "complete") {
    out.push({ tone: "neutral", key: "call_script", label: "Call script from this research", text: "A 30-second opener, two discovery questions and the likely objection.", actions: actions.callScript ? [{ label: "Write call script", run: actions.callScript }] : [] });
  }
  return out;
};

export default deepResearchFindings;
